import { getLocaleStore } from '@/i18n/index';
import { getSysType, SYSTEM_TYPE } from '@/utils/platform-kit';

export enum HOTKEY_TYPE {
    /** 撤销 */
    undo = 'undo',
    /** 重做 */
    redo = 'redo',
    /** 删除 */
    delete = 'delete',
    /** 剪切 */
    cut = 'cut',
    /** 复制 */
    copy = 'copy',
    /** 粘贴 */
    paste = 'paste',
    /** 创建副本 */
    createCopy = 'createCopy',
    /** 固定位置粘贴 */
    fixedPaste = 'fixedPaste',
    /** 左移 */
    left = 'left',
    /** 右移 */
    right = 'right',
    /** 上移 */
    up = 'up',
    /** 下移 */
    down = 'down',
    /** 快速上移 */
    quickUp = 'quickUp',
    /** 快速下移 */
    quickDown = 'quickDown',
    /** 快速左移 */
    quickLeft = 'quickLeft',
    /** 快速右移 */
    quickRight = 'quickRight',
    /** 成组 */
    makeGroup = 'makeGroup',
    /** 解组 */
    brokeGroup = 'brokeGroup',
    /** 全选 */
    selectAll = 'selectAll',
    /** 多选 */
    select = 'select',
    /** 锁定图层 */
    lock = 'lock',
    /** 上移一层 */
    sortUp = 'sortUp',
    /** 下移一层 */
    sortDown = 'sortDown',
    /** 置底 */
    sortTop = 'sortTop',
    /** 置顶 */
    sortBottom = 'sortBottom',
    /** 保存 */
    save = 'save',
    /** 保存记录 */
    saveRecord = 'saveRecord',
    /** 移动 */
    move = 'move',
    /** 快速移动 */
    quickMove = 'quickMove',
    /** 舞台缩放 */
    scale = 'scale',
    /** 退出全屏 */
    esc = 'esc',
    /** 新建文字 */
    T = 'T',
    /** 新建矩形 */
    R = 'R',
    /** 新建圆形 */
    O = 'O',
    /** 新增直线 */
    L = 'L',
    /** 显示、隐藏参考线 */
    toggleReferenceLine = 'toggleReferenceLine',
    /** 显示、隐藏标尺 */
    toggleRulerBar = 'toggleRulerBar',
}

export const hotkeyConfigArr = () => {
    const { $t } = getLocaleStore();

    return [
        {
            key: HOTKEY_TYPE.undo,
            name: $t((v) => v.keyboardKeyMap.undo),
            win: 'Ctrl Z',
            mac: '⌘ Z',
            press: ['Ctrl+Z', 'Command+Z'],
        },
        {
            key: HOTKEY_TYPE.redo,
            name: $t((v) => v.keyboardKeyMap.redo),
            win: 'Shift Ctrl Z',
            mac: '⇧ ⌘ Z',
            press: ['Shift+Ctrl+Z', 'Shift+Command+Z', 'Ctrl+y', 'Command+y'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.delete),
            win: 'Delete/Backspace',
            mac: 'Delete',
            key: HOTKEY_TYPE.delete,
            press: ['Delete', 'Backspace'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.cut),
            win: 'Ctrl X',
            mac: '⌘ X',
            key: HOTKEY_TYPE.cut,
            press: ['Ctrl+X', 'Command+X'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.copy),
            win: 'Ctrl C',
            mac: '⌘ C',
            key: HOTKEY_TYPE.copy,
            press: [],
        },
        {
            name: $t((v) => v.keyboardKeyMap.paste),
            win: 'Ctrl V',
            mac: '⌘ V',
            key: HOTKEY_TYPE.paste,
            press: [],
        },
        {
            name: $t((v) => v.keyboardKeyMap.fixedPaste),
            win: 'Shift Ctrl V',
            mac: '⇧ ⌘ V',
            key: HOTKEY_TYPE.fixedPaste,
            press: ['Ctrl+Shift+V', 'Command+Shift+V'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.createCopy),
            win: 'Ctrl D',
            mac: '⌘ D',
            key: HOTKEY_TYPE.createCopy,
            press: ['Ctrl+D', 'Command+D'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.selectAll),
            win: 'Ctrl A',
            mac: '⌘ A',
            key: HOTKEY_TYPE.selectAll,
            press: ['Ctrl+A', 'Command+A'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.multipleSelect),
            win: $t((v) => v.keyboardKeyMap.multipleSelectDescWin),
            mac: $t((v) => v.keyboardKeyMap.multipleSelectDescMac),
            key: HOTKEY_TYPE.select,
            press: [],
        },
        {
            name: $t((v) => v.keyboardKeyMap.makeGroup),
            win: 'Ctrl G',
            mac: '⌘ G',
            key: HOTKEY_TYPE.makeGroup,
            press: ['Ctrl+G', 'Command+G'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.brokeGroup),
            win: 'Shift Ctrl G',
            mac: '⇧ ⌘ G',
            key: HOTKEY_TYPE.brokeGroup,
            press: ['Ctrl+Shift+G', 'Command+Shift+G'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.lock),
            win: 'Shift Ctrl L',
            mac: '⇧ ⌘ L',
            key: HOTKEY_TYPE.lock,
            press: ['Command+Shift+L', 'Shift+Ctrl+L'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.saveRecord),
            win: 'Ctrl S',
            mac: '⌘ S',
            key: HOTKEY_TYPE.save,
            press: ['Ctrl+S', 'Command+S'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.move),
            win: $t((v) => v.keyboardKeyMap.ArrowKey),
            mac: $t((v) => v.keyboardKeyMap.ArrowKey),
            key: HOTKEY_TYPE.move,
            press: ['Up', 'Right', 'Down', 'Left'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.move),
            win: $t((v) => v.keyboardKeyMap.ArrowKey),
            mac: $t((v) => v.keyboardKeyMap.ArrowKey),
            key: HOTKEY_TYPE.quickMove,
            press: [['Shift+Up'], ['Shift+Right'], ['Shift+Down'], ['Shift+Left']],
        },
        {
            name: $t((v) => v.keyboardKeyMap.scale),
            win: 'Ctrl +/-',
            mac: '⌘ +/-',
            key: HOTKEY_TYPE.scale,
            press: [
                ['Ctrl++', 'Command++', 'Ctrl+=', 'Command+='],
                ['Ctrl+-', 'Command+-', 'Ctrl+_', 'Command+_'],
            ],

            // ignoreDisablePick: true,
        },

        {
            name: $t((v) => v.keyboardKeyMap.sortTop),
            win: 'Shift Ctrl ↑',
            mac: '⇧ ⌘ ↑',
            key: HOTKEY_TYPE.sortTop,
            press: ['Shift+Ctrl+Up', 'Shift+Command+Up'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.sortBottom),
            win: 'Shift Ctrl ↓',
            mac: '⇧ ⌘ ↓',
            key: HOTKEY_TYPE.sortBottom,
            press: ['Shift+Ctrl+Down', 'Shift+Command+Down'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.sortUp),
            win: 'Ctrl ↑',
            mac: '⌘ ↑',
            key: HOTKEY_TYPE.sortUp,
            press: ['Ctrl+Up', 'Command+Up'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.sortDown),
            win: 'Ctrl ↓',
            mac: '⌘ ↓',
            key: HOTKEY_TYPE.sortDown,
            press: ['Ctrl+Down', 'Command+Down'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.exitFullScreen),
            key: HOTKEY_TYPE.esc,
            win: $t((v) => v.keyboardKeyMap.esc),
            mac: $t((v) => v.keyboardKeyMap.esc),
            press: ['ESC'],

            ignoreDisablePick: true,
        },
        {
            name: $t((v) => v.keyboardKeyMap.createText),
            key: HOTKEY_TYPE.T,
            win: 'T',
            mac: 'T',
            press: ['T'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.createLine),
            key: HOTKEY_TYPE.L,
            win: 'L',
            mac: 'L',
            press: ['L'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.createRect),
            key: HOTKEY_TYPE.R,
            win: 'R',
            mac: 'R',
            press: ['R'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.createCircle),
            key: HOTKEY_TYPE.O,
            win: 'O',
            mac: 'O',
            press: ['O'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.toggleReferenceLine),
            win: 'Ctrl ;',
            mac: '⌘ ;',
            key: HOTKEY_TYPE.toggleReferenceLine,
            press: ['Ctrl+;', 'Command+;'],
        },
        {
            name: $t((v) => v.keyboardKeyMap.toggleRulerBar),
            win: 'Shift r',
            mac: '⇧ r',
            key: HOTKEY_TYPE.toggleRulerBar,
            press: ['Shift+r'],
        },
    ];
};

export const hotkeyConfigMap = {};
hotkeyConfigArr().forEach((item) => {
    hotkeyConfigMap[item.key] = item;
});

const system = getSysType();
const prefix = system === SYSTEM_TYPE.MAC ? 'mac' : 'win';

export const getHotkeyMenu = (key: HOTKEY_TYPE) => {
    return hotkeyConfigMap[key][prefix];
};

export default hotkeyConfigMap;
